import clsx from 'clsx';
import Enllac from '../../../../components/3catinfo/Enllac';
import Icona from '../../../../components/3catinfo/ui/Icona';
import LogoDirecte from '../../../../components/3catinfo/ui/LogoDirecte';
import ProgressBar from '../../../../components/3catinfo/ui/ProgressBar';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatDirecte.module.scss';

const _getCanal = (canal) => {
    switch (canal) {
        case 'CAD_ES3':
            return 'esport3';
        case 'CAD_OCA1':
        case 'CAD_OCA2':
        case 'CAD_OCA3':
        case 'CAD_OCA4':
            return 'oca1';
        default:
            return canal;
    }
};

const _getInfoVideo = (e) => {
    return {
        titol: e.ara_fem?.titol_programa,
        capitol: e.ara_fem?.titol_capitol || e.ara_fem?.capitols?.[0].desc,
        link: e.ara_fem?.codi_canal,
        canal: e.ara_fem?.codi_canal,
        logo: e.ara_fem?.logo,

        start_time: e.ara_fem?.start_time,
        end_time: e.ara_fem?.end_time,
        codi_etic: e.ara_fem?.codis_etics,
        drets_cat: e.ara_fem?.drets_cat !== 'no',
        tipusDirecte: e.ara_fem?.tipus
    };
};

const DestacatDirecte = (props) => {
    const { item, estil, marcatgeAudienciesClick, testId, tipus } = props;
    const finalInfo = _getInfoVideo(item);
    const { logo, imatge, start_time, end_time } = finalInfo;
    let { canal, titol } = finalInfo;
    let disponible = item.ara_fem?.drets_cat !== 'no';

    if (__isEmpty(titol) && __isEmpty(imatge) && __isEmpty(finalInfo.link)) {
        if (item.name === 'c33') {
            canal = 'c33';
            titol = 'El canal emet de 21.30 a 05.59';
            disponible = false;
        } else {
            return <></>;
        }
    }

    const route = {
        type: `web_3cat_directe_item_${canal}`
    };

    const stylesItemDirecte = clsx({
        [styles.itemDirecte]: true,
        [styles.inactiu]: !disponible,
        [styles[estil]]: !!estil
    });

    const stylesTitolIcona = clsx({
        [styles.titolAmbIcona]: tipus === 'radio'
    });

    // amaguem els canals que no són d'informatius
    if (!titol || canal === 'esport3' || canal === 'sx3' || canal === 'c33' || canal === 'ic' || canal === 'cm') {
        return <></>;
    }

    return (
        <div className={`${stylesItemDirecte}`} {...(testId && { 'data-testid': testId })} role='article'>
            <Enllac
                className={styles.directeEnllac}
                route={route}
                disponible={disponible}
                marcatgeAudienciesClick={marcatgeAudienciesClick}
                dataTestId='destacat-enllac'
            >
                <div className={styles.logoWrapper}>
                    <LogoDirecte className={`${canal} ${styles.logocanal}`} canal={_getCanal(canal)} logo={logo} />
                </div>

                <div className={stylesTitolIcona}>
                    {titol && (
                        <div className={styles.titol} data-testid='destacat-titol'>
                            <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                        </div>
                    )}
                    {tipus === 'radio' && (
                        <Icona icona='auriculars' alt='ràdio' isBlanc={false} mida={24} className={styles.linktitol} />
                    )}
                </div>

                <ProgressBar className={styles.progres} start_time={start_time} end_time={end_time} />
            </Enllac>
        </div>
    );
};

export default DestacatDirecte;
